import React, { useState, useRef } from "react";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import * as Style from "./styles";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Loading } from "../../components/Loading";
import { InputMask } from "../../components/InputMask";

export const Login = () => {
  // Pegamos as funções existentes E AS NOVAS do hook
  const { sideIn, requestLoginCode, verifyLoginCode } = useAuth();
  const navigate = useNavigate();

  // Estados para Login/Senha
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  // --- NOVOS ESTADOS para Login/WhatsApp ---
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");

  // Estados de UI e Erro
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // --- NOVOS ESTADOS de controle da UI ---
  // 'password' ou 'phone'
  const [loginMethod, setLoginMethod] = useState('password');
  // 'request' (pedir código) ou 'verify' (validar código)
  const [phoneStep, setPhoneStep] = useState('request');

  const buttonRef = useRef(null);

  // --- Handler para Login/Senha (Sem alterações) ---
  const handlePasswordLogin = async () => {
    if (!login | !password) {
      setError("Preencha todos os campos");
      return;
    }
    setLoading(true)
    var result = await sideIn(login, password)
    if (result) {
      setError(result);
      setLoading(false)
      return;
    }
    navigate("/home/dashboard");
  };

  // --- NOVO HANDLER: Pedir código do WhatsApp ---
  const handleRequestCode = async () => {
    if (!phone) {
      setError("Preencha o campo telefone (com DDD)");
      return;
    }
    setLoading(true);
    setError("");
    const result = await requestLoginCode(phone);
    setLoading(false);

    if (result.success) {
      setPhoneStep('verify'); // Avança para a etapa de verificação
    } else {
      setError(result.message); // Exibe erro (ex: telefone não encontrado)
    }
  };

  // --- NOVO HANDLER: Verificar código e logar ---
  const handleVerifyCode = async () => {
    if (!phone || !code) {
      setError("Preencha o código recebido");
      return;
    }
    setLoading(true);
    setError("");
    // Esta função já faz o login e armazena o token
    const result = await verifyLoginCode(phone, code);

    if (result) { // Se 'result' tiver algo, é uma msg de erro
      setError(result);
      setLoading(false);
      return;
    }

    // Sucesso (result === ''), navega para home
    navigate("/home/dashboard");
  };

  // --- Atualiza o KeyPress para os novos campos ---
  const handleKeyPress = async (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();

      if (loginMethod === 'password') {
        await handlePasswordLogin();
      } else {
        // Se estiver no fluxo de telefone
        if (phoneStep === 'request') {
          await handleRequestCode();
        } else {
          await handleVerifyCode();
        }
      }
    }
  };

  // --- Função para alternar o formulário ---
  const toggleLoginMethod = (e) => {
    e.preventDefault(); // Impede o link de navegar
    setLoginMethod(prev => (prev === 'password' ? 'phone' : 'password'));
    setError("");
    setPhone("");
    setCode("");
    setPhoneStep('request'); // Reseta o fluxo do telefone
  };

  return (
    <Style.Container>
      <Loading loading={loading} />
      <Style.BackImg>
        <Style.Img src="/assets/images/img/MULTLEADS_original.jpg" />
      </Style.BackImg>
      <Style.Content>
        <Style.ImgLogo src="/assets/images/img/logo.png" />

        {/* --- RENDERIZAÇÃO CONDICIONAL DO FORMULÁRIO --- */}

        {loginMethod === 'password' ? (
          <>
            {/* --- Formulário de Login/Senha (Existente) --- */}
            <Input
              text="Login"
              placeholder="Digite seu login"
              value={login}
              onChange={(e) => [setLogin(e.target.value), setError("")]}
              onKeyPress={handleKeyPress}
            />
            <Input
              text="Senha"
              type="password"
              placeholder="Digite sua Senha"
              value={password}
              onChange={(e) => [setPassword(e.target.value), setError("")]}
              onKeyPress={handleKeyPress}
            />
            <Style.labelError>{error}</Style.labelError>
            <Button onClick={handlePasswordLogin}>Entrar</Button>

            {/* Link para alternar */}
            <Style.Strong>
              <a href="#" onClick={toggleLoginMethod}>&nbsp;Entrar com WhatsApp</a>
            </Style.Strong>
          </>
        ) : (
          <>
            {/* --- Formulário de Telefone/Código (Novo) --- */}
            <Input
              text="Telefone (com DDD)"
              placeholder="Ex: 11999998888"
              value={phone}
              onChange={(e) => [setPhone(e.target.value), setError("")]}
              onKeyPress={handleKeyPress}
              // Desabilita o campo de telefone após enviar o código
              disabled={phoneStep === 'verify'}
            />

            {/* Só mostra o campo de código se já solicitou */}
            {phoneStep === 'verify' && (
              <Input
                text="Código"
                placeholder="Digite o código de 6 dígitos"
                value={code}
                onChange={(e) => [setCode(e.target.value), setError("")]}
                onKeyPress={handleKeyPress}
              />
            )}

            <Style.labelError>{error}</Style.labelError>

            {/* Alterna o botão dependendo da etapa */}
            {phoneStep === 'request' ? (
              <Button onClick={handleRequestCode}>Enviar Código</Button>
            ) : (
              <Button onClick={handleVerifyCode}>Verificar e Entrar</Button>
            )}

            {/* Link para alternar de volta */}
            <Style.Strong>
              <a href="#" onClick={toggleLoginMethod}>&nbsp;Entrar com Login/Senha</a>
            </Style.Strong>
          </>
        )}

        {/* Link de Recuperar Senha (mantido) */}
        <Style.Strong>
          <Link to="/register">&nbsp;Recuperar senha</Link>
        </Style.Strong>

      </Style.Content>
    </Style.Container>
  );
};

// import React, { useState, useRef} from "react";
// import { LoadingOutlined } from '@ant-design/icons';
// import { Spin } from 'antd';
// import {Input} from "../../components/Input";
// import {Button} from "../../components/Button";
// import * as Style from "./styles";
// import { Link, useNavigate } from "react-router-dom";
// import useAuth from "../../hooks/useAuth";
// import { Loading } from "../../components/Loading";

// export const Login = () => {
//   const {sideIn} = useAuth();
//   const navigate = useNavigate();

//   const [login, setLogin] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const buttonRef = useRef(null);

//   const handleLogin = async() => {
//     if (!login | !password) {
//       setError("Preencha todos os campos");
//       return;
//     }
//     setLoading(true)
//     var result = await sideIn(login, password)
//     if (result) {
//       setError(result);
//       setLoading(false)
//       return;
//     }
//     navigate("/home/dashboard");
//   };

//   const handleKeyPress = async  (event) => {
//     if (event.key === 'Enter') {
//       event.preventDefault();
//       await handleLogin();
//     }
//   };
//   return (
//     <Style.Container>
//       <Loading loading={loading}/>
//       <Style.BackImg>
//           <Style.Img src="/assets/images/img/MULTLEADS_original.jpg"/>
//       </Style.BackImg>
//       <Style.Content>
//       <Style.ImgLogo src="/assets/images/img/logo.png"/>
//         <Input
//           text="Login"
//           // type="email"
//           placeholder="Digite seu login"
//           value={login}
//           onChange={(e) => [setLogin(e.target.value), setError("")]}
//           onKeyPress={handleKeyPress}
//         />
//         <Input
//           text="Senha"
//           type="password"
//           placeholder="Digite sua Senha"
//           value={password}
//           onChange={(e) => [setPassword(e.target.value), setError("")]}
//           onKeyPress={handleKeyPress}
//         />
//         <Style.labelError>{error}</Style.labelError>
//         <Button onClick={handleLogin}>Entrar</Button>
//           <Style.Strong>
//             <Link to="/register">&nbsp;Recuperar senha</Link>
//           </Style.Strong>
//       </Style.Content>
//     </Style.Container>
//   );
// };

